import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import conciergeApiClient from "Services/Apis/Concierge/conciergeApiClient";

export const createSupplierThunk = createAsyncThunk(
  "CreateSupplierSlice/CreateSupplierThunk",
  async (supplier, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const config = { headers };

    const body = { ...supplier };

    const { data } = await conciergeApiClient.post(`Supplier`, body, config);

    return data;
  }
);

const initialState = {
  supplierCreationData: false,
  isSupplierCreationLoading: false,
  supplierCreationHasErrors: false,
};

const createSupplierSlice = createSlice({
  name: "CreateSupplierSlice",
  initialState,
  reducers: {
    resetSupplierCreationData: (state) => {
      state.supplierCreationData = null;
      state.isSupplierCreationLoading = false;
      state.supplierCreationHasErrors = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createSupplierThunk.pending, (state) => {
      state.supplierCreationData = null;
      state.isSupplierCreationLoading = true;
      state.supplierCreationHasErrors = false;
    });

    builder.addCase(createSupplierThunk.fulfilled, (state, action) => {
      state.supplierCreationData = action.payload;
      state.isSupplierCreationLoading = false;
      state.supplierCreationHasErrors = false;
    });

    builder.addCase(createSupplierThunk.rejected, (state) => {
      state.supplierCreationData = null;
      state.isSupplierCreationLoading = false;
      state.supplierCreationHasErrors = true;
    });
  },
});

export const { resetSupplierCreationData } = createSupplierSlice.actions;

export default createSupplierSlice.reducer;